export default __webpack_public_path__ + "../img/e2af1bca52c5d4c427726376b1f0b11e.svg";